// authProvider.js
import { MsalAuthProvider, LoginType } from 'react-aad-msal';
 
// Msal Configurations
const config = {
  auth: {
    authority: 'https://login.microsoftonline.com/payoneerinc.onmicrosoft.com',
    clientId: 'e968bbfd-4fc2-4c46-a16e-f7dea6e8759c',
    redirectUri: window.location.hostname === "localhost" ? 'http://localhost:3000/' : "https://the-5th.azurewebsites.net/",
    tenant: 'decee90c-ce03-461e-8c21-dd538e181c75'
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true
  }
};
 
// Authentication Parameters
const authenticationParameters = {
  scopes: [
    'https://graph.windows.net/User.Read'
  ]
}
 
// Options
// const options = {
//   loginType: LoginType.Popup,
//   tokenRefreshUri: window.location.origin + '/auth.html'
// }
 
export const authProvider = new MsalAuthProvider(config, authenticationParameters, LoginType.Redirect)